import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Collapse from '@mui/material/Collapse';
import Radio from '../Radio/Radio';
import Toggle from '../Toggle';
import Grid from '../Grid';
import DropdownItem from '../Dropdown/DropdownItem';
import DropdownList from '../Dropdown/DropdownList';
import { StyledComparisonCard, StyledComparisonHeader, StyledComparisonHeaderLabel } from './styles';
import type { ComparisonPanelProps } from './types';
const ComparisonPanel = t0 => {
  const $ = _c(28);
  const {
    enabled,
    onEnabledChange,
    lockEnabled: t1,
    presets,
    selectedPreset,
    onSelectPreset,
    label: t2
  } = t0;
  const lockEnabled = t1 === undefined ? false : t1;
  const label = t2 === undefined ? "Comparison" : t2;
  let t3;
  if ($[0] !== label) {
    t3 = <StyledComparisonHeaderLabel variant="body2">{label}</StyledComparisonHeaderLabel>;
    $[0] = label;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== onEnabledChange) {
    t4 = (_event, checked) => {
      onEnabledChange(checked);
    };
    $[2] = onEnabledChange;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== enabled || $[5] !== lockEnabled || $[6] !== t4) {
    t5 = <Toggle checked={enabled} disabled={lockEnabled} onChange={t4} />;
    $[4] = enabled;
    $[5] = lockEnabled;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <StyledComparisonHeader>{t3}{t5}</StyledComparisonHeader>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== enabled || $[12] !== onSelectPreset || $[13] !== presets || $[14] !== selectedPreset) {
    let t8;
    if ($[16] !== enabled || $[17] !== onSelectPreset || $[18] !== selectedPreset) {
      t8 = preset => {
        const isActive = selectedPreset === preset.value;
        return <DropdownItem key={preset.value} disabled={!enabled} onClick={() => onSelectPreset?.(preset.value)} aria-label={`Select comparison ${preset.label}`} aria-pressed={isActive} control={<Grid display="flex" alignItems="center" columnGap="16px"><Radio checked={isActive} value={preset.value} /></Grid>}>{preset.label}</DropdownItem>;
      };
      $[16] = enabled;
      $[17] = onSelectPreset;
      $[18] = selectedPreset;
      $[19] = t8;
    } else {
      t8 = $[19];
    }
    t7 = presets.map(t8);
    $[11] = enabled;
    $[12] = onSelectPreset;
    $[13] = presets;
    $[14] = selectedPreset;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[20] !== t7) {
    t8 = <DropdownList dense={true}>{t7}</DropdownList>;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== enabled || $[23] !== t8) {
    t9 = <Collapse in={enabled}>{t8}</Collapse>;
    $[22] = enabled;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t6 || $[26] !== t9) {
    t10 = <StyledComparisonCard>{t6}{t9}</StyledComparisonCard>;
    $[25] = t6;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
};
ComparisonPanel.displayName = 'ComparisonPanel';
export default ComparisonPanel;